<div class="rounded-3xl border border-gray-200/80 bg-white/40 p-4 shadow-sm dark:border-[#191e3a] dark:bg-dark/10 md:p-6">
  <button type="button" class="flex w-full items-center justify-between" (click)="toggle()">
    <span class="text-sm font-semibold text-gray-800 dark:text-white">
      Compliance locks for {{ countryCode }}
      <span class="ml-2 text-xs font-normal text-gray-500">({{ locks.length }})</span>
    </span>
    <span class="text-gray-400">{{ open ? '▾' : '▸' }}</span>
  </button>

  <div *ngIf="open" class="mt-4">
    <p *ngIf="loading" class="text-sm text-gray-500">Loading locks…</p>
    <p *ngIf="!loading && locks.length === 0" class="text-sm text-gray-500">No compliance locks for this pack.</p>
    <table *ngIf="!loading && locks.length > 0" class="w-full text-left text-xs">
      <thead class="text-gray-500 dark:text-gray-400">
        <tr>
          <th class="py-1.5 pr-3">Parameter</th>
          <th class="py-1.5 pr-3">Minimum</th>
          <th class="py-1.5 pr-3">Regulation</th>
          <th class="py-1.5">Description</th>
        </tr>
      </thead>
      <tbody class="text-gray-700 dark:text-gray-300">
        <tr *ngFor="let lock of locks" class="border-t border-gray-100 dark:border-[#191e3a]">
          <td class="py-1.5 pr-3 font-mono">{{ lock.parameter_key }} 🔒</td>
          <td class="py-1.5 pr-3">{{ lock.minimum_value }}</td>
          <td class="py-1.5 pr-3">{{ lock.regulation }} {{ lock.regulation_article }}</td>
          <td class="py-1.5">{{ lock.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
